import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { CookieService } from 'ngx-cookie-service';

import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { CoreModule } from './core/core.module';
import { AuthGuard } from './core/guards/auth-guard.service';
import { PostLoginFooterComponent } from './shared/layout/postLoginFooter/postLoginFooter.component';
import { AuthModule } from './auth/auth.module';
//import { MatGoogleMapsAutocompleteModule } from '@angular-material-extensions/google-maps-autocomplete';
// import { AgmCoreModule } from '@agm/core';
import { GeolocationBlockerService } from './core/services/geolocation-blocker.service';
import { AppRoutingModule } from './app-routing.module';
import { NgMapsGoogleModule } from '@ng-maps/google';
//import { LoaderComponent } from './shared/loader/loader.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { NgxMaskModule } from 'ngx-mask';

import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { ShareService } from 'ngx-sharebuttons';
import { RecaptchaV3Module, RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { NgxLinkifyjsModule } from 'ngx-linkifyjs-v2';
import { environment } from '../environments/environment';
import { firstValueFrom } from 'rxjs';
import { AuthService } from './core/services/auth.service';

export function initializeAuthSession(authService: AuthService) {
  return () => firstValueFrom(authService.initializeSession()).then(() => true);
}
@NgModule({
  declarations: [AppComponent, PostLoginFooterComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    SharedModule,
    CoreModule.forRoot(),
    NgxLinkifyjsModule.forRoot(),
    AppRoutingModule,
    AuthModule,
    BsDatepickerModule.forRoot(),
    NgxMaskModule.forRoot(),
    NgMapsGoogleModule.forRoot({
      apiKey: environment.googleMapsApiKey,
      libraries: ['places'],
    }),
    // AgmCoreModule.forRoot(),
    //LoaderComponent,
    RecaptchaV3Module,
  ],
  providers: [
    CookieService,
    AuthGuard,
    GeolocationBlockerService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeAuthSession,
      deps: [AuthService],
      multi: true,
    },
    { provide: RECAPTCHA_V3_SITE_KEY, useValue: environment.recaptchaSiteKey },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor(library: FaIconLibrary, share: ShareService) {
    // ← add ShareService
    library.addIcons(faXTwitter);

    // Global X (Twitter) override — applies to all share buttons in the app
    const twitter = share.prop?.['twitter'];
    if (twitter) {
      twitter.icon = ['fab', 'x-twitter'];
      twitter.text = 'X';
      twitter.color = '#000000';
    }

    // `mailto:` should hand control to the device's mail client. Opening it in
    // a blank browser target is unreliable in Safari/iPadOS.
    const email = share.prop?.['email'];
    if (email) {
      email.target = '_self';
    }
  }
}
